import styled from "styled-components";

export default styled.div`
  overflow: auto;
  height: 85vh;
  display: flex;
  flex-direction: column-reverse;
  overflow-anchor: auto !important;
  padding: 1rem;
  min-height: auto;

  .chat-page {
    padding-top: 80px;
  }

  @media screen and (max-width: 768px) {
    height: 97vh;

    .chat-page {
      padding-top: 70px;
      padding-bottom: 50px;
    }
  }
`;
